<template>
    <div class="container page-content mt-10 mb-3">
        <div class="row">
            <div class="col-12">
                <h1 class="page-heading text-dark dashbaord-heading">
                    {{ $t('dashboard.welcome') }}, {{ $store.state.user.username }}
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6 col-xxl-4 row dashboard-row">
                <div class="col-12">
                    <h3>{{ $t('dashboard.rows.shopping') }}</h3>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/shop" class="w-100 dashboard-row-link menu-shop">
                        <span>{{ $t('dashboard.pages.shop') }}</span>
                    </router-link>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/marketplace" class="w-100 dashboard-row-link menu-marketplace">
                        <span>{{ $t('dashboard.pages.marketplace') }}</span>
                    </router-link>
                </div>
            </div>

            <div class="col-12 col-md-6 col-xxl-4 row dashboard-row">
                <div class="col-12">
                    <h3>{{ $t('dashboard.rows.mystuff') }}</h3>
                </div>

                <div class="col-4 dashboard-row-item">
                    <router-link to="/inventory" class="w-100 dashboard-row-link menu-boosters">
                        <span>{{ $t('dashboard.pages.boosters') }}</span>
                    </router-link>
                </div>

                <div class="col-4 dashboard-row-item">
                    <router-link to="/my-cards" class="w-100 dashboard-row-link menu-cards">
                        <span>{{ $t('dashboard.pages.cards') }}</span>
                    </router-link>
                </div>

                <div class="col-4 dashboard-row-item">
                    <router-link to="/collections" class="w-100 dashboard-row-link menu-collection">
                        <span>{{ $t('dashboard.pages.collections') }}</span>
                    </router-link>
                </div>
            </div>

            <div class="col-12 col-md-6 col-xxl-4 row dashboard-row">
                <div class="col-12">
                    <h3>{{ $t('dashboard.rows.discover') }}</h3>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/search" class="w-100 dashboard-row-link menu-search">
                        <span>{{ $t('dashboard.pages.search') }}</span>
                    </router-link>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/gallery" class="w-100 dashboard-row-link menu-sets">
                        <span>{{ $t('dashboard.pages.gallery') }}</span>
                    </router-link>
                </div>
            </div>

            <div class="col-12 col-md-6 col-xxl-4 row dashboard-row">
                <div class="col-12">
                    <h3>{{ $t('dashboard.rows.social') }}</h3>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/social" class="w-100 dashboard-row-link menu-social">
                        <span>{{ $t('dashboard.pages.social') }}</span>
                    </router-link>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/trading" class="w-100 dashboard-row-link menu-trading">
                        <span>{{ $t('dashboard.pages.trading') }}</span>
                    </router-link>
                </div>
            </div>

            <div class="col-12 col-md-6 col-xxl-4 row dashboard-row">
                <div class="col-12">
                    <h3>{{ $t('dashboard.rows.games') }}</h3>
                </div>

                <div class="col-4 dashboard-row-item">
                    <router-link to="/quiz" class="w-100 dashboard-row-link menu-quiz">
                        <span>{{ $t('dashboard.pages.quiz') }}</span>
                    </router-link>
                </div>

                <div class="col-4 dashboard-row-item">
                    <router-link to="/pokewordle" class="w-100 dashboard-row-link menu-pokewordle">
                        <span>{{ $t('dashboard.pages.pokewordle') }}</span>
                    </router-link>
                </div>

                <div class="col-4 dashboard-row-item">
                    <router-link to="/slot" class="w-100 dashboard-row-link menu-slot">
                        <span>{{ $t('dashboard.pages.casino') }}</span>
                    </router-link>
                </div>
            </div>

            <div class="col-12 col-md-6 col-xxl-4 row dashboard-row">
                <div class="col-12">
                    <h3>{{ $t('dashboard.rows.other') }}</h3>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/settings" class="w-100 dashboard-row-link menu-settings">
                        <span>{{ $t('dashboard.pages.settings') }}</span>
                    </router-link>
                </div>

                <div class="col-6 dashboard-row-item" v-if="$store.state.user.isAdmin">
                    <a href="/admin" class="w-100 dashboard-row-link menu-administration">
                        <span>{{ $t('dashboard.pages.administration') }}</span>
                    </a>
                </div>
            </div>

            <div class="col-12 col-md-6 col-xxl-4 row dashboard-row" v-if="$store.state.user.isAdmin">
                <div class="col-12">
                    <h3>WIP</h3>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/decks" class="w-100 dashboard-row-link menu-decks">
                        <span>{{ $t('dashboard.pages.decks') }}</span>
                    </router-link>
                </div>

                <div class="col-6 dashboard-row-item">
                    <router-link to="/grading" class="w-100 dashboard-row-link menu-grading">
                        <span>{{ $t('dashboard.pages.grading') }}</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Dashboard",
    data() {
        return {};
    },
    mounted() {
        this.$store.commit('updateUserData');
    },
    computed: {},
    watch: {},
    methods: {
        //
    },
};
</script>


<style scoped lang="scss">
.dashboard-row {
    display: flex;
    justify-content: space-evenly;

    .dashboard-row-item {
        text-align: center;
        height: 15em;
        background-size: cover;
        display: flex;
        align-content: flex-end;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 1.25em;

        .dashboard-row-link {
            display: flex;
            align-content: flex-end;
            flex-wrap: wrap;
            justify-content: center;
            border: 1px solid black;
            border-radius: 5px;

            font-size: 2em;
            font-weight: bold;
            color: white;
            width: 100%;
            height: 100%;
            text-transform: none;
            text-decoration: none;
            text-shadow: 1px 1px #0a0a0a, -1px -1px #0a0a0a;

            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            span {
                display: block;
                width: 100%;
                background-color: rgba(0, 0, 0, 0.5);
            }
        }

        &:is(.col-4) {
            .dashboard-row-link {
                font-size: 1.75em;
            }
        }
    }
}

.menu-marketplace {
    background-image: url('/assets/dipocaco/pocas/market.jpg');
}

.menu-shop {
    background-image: url('/assets/dipocaco/pocas/shop-poca_sm.jpg');
}

.menu-boosters {
    background-image: url('/assets/dipocaco/pocas/inventory-poca5_sm.jpg');
}

.menu-cards {
    background-image: url('/assets/dipocaco/pocas/mycards-poca_sm.jpg');
}

.menu-collection {
    background-image: url('/assets/dipocaco/pocas/collection-poca_sm.jpg');
}

.menu-decks {
    background-image: url('/assets/dipocaco/pocas/decks-poca_sm.jpg');
}

.menu-trading {
    background-image: url('/assets/dipocaco/pocas/trading-poca_sm.jpg');
}

.menu-social {
    background-image: url('/assets/dipocaco/pocas/social-poca_sm.jpg');
}

.menu-sets {
    background-image: url('/assets/dipocaco/pocas/gallery-poca.jpg');
}

.menu-quiz {
    background-image: url('/assets/dipocaco/pocas/quiz-poca.jpg');
}

.menu-pokewordle {
    background-image: url('/assets/dipocaco/pocas/wordle-poca.jpg');
}

.menu-slot {
    background-image: url('/assets/dipocaco/pocas/casino-poca.jpg');
}

.menu-search {
    background-image: url('/assets/dipocaco/pocas/search-poca.jpg');
}

.menu-settings {
    background-image: url('/assets/dipocaco/pocas/settings-poca.jpg');
}

.menu-administration {
    background-image: url('/assets/dipocaco/pocas/admin-poca.jpg');
}

</style>
